var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCollapsedUp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 1.33332C4.31796 1.33332 1.33329 4.31799 1.33329 7.99999C1.33329 11.682 4.31796 14.6667 7.99996 14.6667C11.682 14.6667 14.6666 11.682 14.6666 7.99999C14.6666 4.31799 11.682 1.33332 7.99996 1.33332Z",
    fill: "#2F2E99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3534 8.84L8.00006 6.49333L5.64673 8.84",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCollapsedUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/collapsedUp.1d808009.svg";
export { ForwardRef as ReactComponent };